import { Component } from 'react';
import PropTypes from 'prop-types';

class DomErrorHandler extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    if (error instanceof DOMException) return { hasError: false };

    return { hasError: true };
  }

  async componentDidCatch(data) {
    const { app } = this.props;
    app.events.emit('monitor:log', { error: data });
  }

  render() {
    const {
      props: { children },
      state: { hasError }
    } = this;

    if (hasError) {
      return <p>Error</p>;
    }
    return children;
  }
}

DomErrorHandler.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]).isRequired,
  app: PropTypes.object.isRequired
};

export default DomErrorHandler;
